import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Menu, X, ArrowUpRight } from "lucide-react";
import { navLinks, companyInfo } from "../mock";

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleNavClick = (e, href) => {
    // href like "/#services"
    e.preventDefault();
    setOpen(false);
    const hash = href.includes("#") ? "#" + href.split("#")[1] : "";
    if (location.pathname === "/") {
      const target = document.querySelector(hash);
      if (target) {
        target.scrollIntoView({ behavior: "smooth", block: "start" });
        window.history.replaceState(null, "", "/" + hash);
      }
    } else {
      navigate("/" + hash);
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "backdrop-blur-md bg-[color:var(--icg-cream)]/85 border-b border-[color:var(--icg-line)]"
          : "bg-transparent"
      }`}
    >
      <div className="icg-container flex items-center justify-between h-[72px]">
        <Link to="/" className="flex items-center gap-2">
          <span className="icg-dot" />
          <span className="font-display font-semibold text-[17px] tracking-tight">
            {companyInfo.name}
            <span className="text-[color:var(--icg-muted)] font-normal">
              {" "}
              / {companyInfo.suffix}
            </span>
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-9">
          {navLinks.map((l) => (
            <a
              key={l.label}
              href={l.href}
              onClick={(e) => handleNavClick(e, l.href)}
              className="text-[14px] font-medium text-[color:var(--icg-ink)] hover:text-[color:var(--icg-accent)] transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <a
          href="/#contact"
          onClick={(e) => handleNavClick(e, "/#contact")}
          className="hidden md:inline-flex icg-btn icg-btn--dark"
          style={{ padding: "10px 18px", fontSize: 14 }}
        >
          Start a project <ArrowUpRight size={16} />
        </a>

        <button
          className="md:hidden p-2 -mr-2"
          aria-label="Toggle menu"
          onClick={() => setOpen(!open)}
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden bg-[color:var(--icg-cream)] border-t border-[color:var(--icg-line)]">
          <div className="icg-container py-6 flex flex-col gap-4">
            {navLinks.map((l) => (
              <a
                key={l.label}
                href={l.href}
                onClick={(e) => handleNavClick(e, l.href)}
                className="text-lg font-medium py-2"
              >
                {l.label}
              </a>
            ))}
            <a
              href="/#contact"
              onClick={(e) => handleNavClick(e, "/#contact")}
              className="icg-btn icg-btn--dark mt-2 w-fit"
            >
              Start a project <ArrowUpRight size={16} />
            </a>
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;
